if (!customElements.get('octaralife-dispatch-date')) {
  customElements.define('octaralife-dispatch-date', class extends HTMLElement {
    connectedCallback() {
      this.refresh = () => this.updateDate();
      this.updateDate();
      this.timer = setInterval(this.refresh, 60000);
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
    updateDate() {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Lisbon', year: 'numeric', month: 'numeric', day: 'numeric'
      }).formatToParts(new Date());
      const part = (type) => Number(parts.find((item) => item.type === type).value);
      const target = new Date(Date.UTC(part('year'), part('month') - 1, part('day') + 2));
      const days = ['dom.', 'seg.', 'ter.', 'qua.', 'qui.', 'sex.', 'sáb.'];
      const months = ['jan.', 'fev.', 'mar.', 'abr.', 'mai.', 'jun.', 'jul.', 'ago.', 'set.', 'out.', 'nov.', 'dez.'];
      const date = this.querySelector('strong');
      if (date) date.textContent = days[target.getUTCDay()] + ', ' + target.getUTCDate() + ' ' + months[target.getUTCMonth()];
    }
  });
}
